import { EmojiPicker as EmojiPickerCore } from "@/components/ui/editor/core/components/emoji-picker";
import { useEditorContext } from "../rich-text-editor-provider";

export const EmojiPicker = () => {
  const { editor } = useEditorContext("Editor");
  if (!editor) return null;
  return <EmojiPickerCore editor={editor} />;
};
